module.exports = __webpack_public_path__ + "img/img5-8.ee0c968b.jpg";